import { ReactNode } from 'react';

interface RevealCardProps {
  icon: ReactNode;
  title: string;
  description: string;
  buttonLabel: string;
  buttonIcon?: ReactNode;
  onReveal: () => void;
  onHide?: () => void;
  revealed?: boolean;
  loadedLabel?: string;
  hideLabel?: string;
}

export function RevealCard({
  icon,
  title,
  description,
  buttonLabel,
  buttonIcon,
  onReveal,
  onHide,
  revealed = false,
  loadedLabel = 'Loaded',
  hideLabel = 'Hide',
}: RevealCardProps) {
  const showHide = revealed && !!onHide;
  return (
    <div className="bg-white rounded-xl border border-gray-200 p-8">
      <div className="flex items-start gap-4">
        <div className="w-12 h-12 bg-gray-50 border border-gray-200 rounded-xl flex items-center justify-center flex-shrink-0 text-gray-600">
          {icon}
        </div>
        <div className="flex-1">
          <h3 className="text-xl font-medium text-gray-900 mb-2">{title}</h3>
          <p className="text-sm text-gray-600 mb-4">{description}</p>
          {showHide ? (
            <button
              onClick={onHide}
              className="bg-white text-gray-700 font-medium py-2 px-6 rounded-lg border border-gray-300 hover:bg-gray-50 transition-colors inline-flex items-center gap-2"
            >
              {hideLabel}
            </button>
          ) : (
            <button
              onClick={onReveal}
              disabled={revealed}
              className="bg-black text-white font-medium py-2 px-6 rounded-lg hover:bg-gray-800 transition-colors inline-flex items-center gap-2 disabled:bg-gray-200 disabled:text-gray-500 disabled:cursor-default"
            >
              {revealed ? loadedLabel : (
                <>
                  {buttonIcon}
                  {buttonLabel}
                </>
              )}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
